import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AcademicComponent } from "src/app/view/campus/academic/academic.component";
import { AdministrativeComponent } from "src/app/view/campus/administrative/administrative.component";
import { CampusComponent } from "src/app/view/campus/campus.component";
import { GroundComponent } from "src/app/view/campus/ground/ground.component";
import { InfraComponent } from "src/app/view/campus/infra/infra.component";
import { LabsComponent } from "src/app/view/campus/labs/labs.component";
import { MusicComponent } from "src/app/view/campus/music/music.component";
import { TransportComponent } from "src/app/view/campus/transport/transport.component";

const route: Routes=[
    {path:'',component:CampusComponent,children:[
        {path:'administrative',component:AdministrativeComponent},
        {path:'academic',component:AcademicComponent},
        {path:'music',component:MusicComponent},
        // {path:'labs',component:LabsComponent},
        {path:'ground',component:GroundComponent},
        {path:'transport',component:TransportComponent},
        {path:'infrastructure',component:InfraComponent}
    ]}
]
@NgModule({
    imports:[
        RouterModule.forChild(route)
    ],
    exports:[
        RouterModule
    ]
})
export class CampusRoutingModule{}